export default __webpack_public_path__ + "static/media/inbox.cbec7f99.svg";